<template>
  <div>
    <BaseButton
      action="principal"
      @click="
        nextStep();
        toggleModal();
      "
    >
      <i slot="icon" class="ml-1">
        <IconPlus class="icon is-small" />
      </i>
      <p slot="text">Select Photo</p>
    </BaseButton>

    <b-modal
      v-model="showModal"
      has-modal-card
      :data-test-id="constants.DATA_TEST_ID_VALUES.CLOSE_MODAL_BUTTON"
    >
      <form onsubmit="return false">
        <div class="modal-card assets__container">
          <header class="modal-card-head">
            <AssetsUpload
              :location="location"
              :location-path="locationPath"
              :category="category"
              :is-loading="isLoading"
              :toggle-loading="toggleLoading"
              :contract-locations="contractLocations"
              :day-locations="dayLocations"
              :filter-destinations="filterDestinations"
              :default-payload="assetsSearchingPayload"
              :set-image-processing-id="setImageProcessingId"
              :validate-function-execution="validateFunctionExecution"
            />
          </header>

          <section class="modal-card-body">
            <AssetsList
              :is-loading="isLoading"
              :toggle-loading="toggleLoading"
              :assets-list="assetsList"
              :handle-asset-on-click="handleAssetOnClick"
              :load-data="loadData"
              :type="type"
              :category="category"
              :location="location"
              :filter-destinations="filterDestinations"
              :location-path="locationPath"
              :contract-locations="contractLocations"
              :image-processing-id="imageProcessingId"
              :default-payload="assetsSearchingPayload"
            />
          </section>
          <GuideBox
            title="Editing your itinerary"
            description="To add this photo, click on 'Add assets'"
            :step="43"
            :position-x="680"
            :position-y="-150"
            :show-next-button="false"
          />
          <GuideBox
            title="Editing your Weblink"
            description="To add this photo to your Weblink, click on 'Add assets'"
            :step="55"
            :position-x="680"
            :position-y="-180"
            :show-next-button="false"
          />
          <footer class="modal-card-foot is-flex is-justify-content-flex-end">
            <BaseButton
              :disabled="isLoading"
              :loading="isLoading"
              action="tercery"
              size="large"
              :class="focusedGuideBoxClass('', [43, 55], false)"
              @click="
                nextStep();
                handleSaveServicesAssets();
              "
            >
              <p
                slot="text"
                :data-test-id="constants.DATA_TEST_ID_VALUES.SAVE_PHOTO_BUTTON"
              >
                Add assets
              </p>
            </BaseButton>
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AssetsList from "./AssetsList.vue";
import AssetsUpload from "./AssetsUpload.vue";
import { getLocationsPath } from "@/utils/itinerary";
import GuideBox from "./GuideBox.vue";
import { CATEGORY_ASSET, ASSET_TYPE } from "@/constants";
import { DATA_TEST_ID_VALUES } from "@/constants/test";
import locationApi from "@/services/locations";

export default {
  name: "AssetsContainer",
  components: {
    AssetsList,
    AssetsUpload,
    GuideBox,
  },
  props: {
    dayLocations: {
      type: [Array, Object],
      default: () => [],
    },
    formWithImages: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      default: CATEGORY_ASSET.LOCATION,
    },
    type: {
      type: String,
      default: () => "",
    },
    locationPathProp: {
      type: String,
      default: () => "",
    },
    assetsSearchingPayload: {
      type: Object,
      default: () => ({
        country: null,
        destination: null,
      }),
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    validateFunctionExecution: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      constants: {
        CATEGORY_ASSET,
        ASSET_TYPE,
        DATA_TEST_ID_VALUES,
      },
      location: "",
      locationPath: this.locationPathProp,
      showModal: false,
      isLoading: false,
      assetsList: [],
      imageProcessingId: null,
    };
  },
  computed: {
    ...mapGetters({
      contractLocations: "client/getCountriesFromContract",
      isUserGuideActive: "userguide/getIsUserGuideActive",
      userGuideStep: "userguide/getStep",
    }),
    hasAssetsSearchDefaultPayload() {
      return (
        this.assetsSearchingPayload &&
        (this.assetsSearchingPayload.country ||
          this.assetsSearchingPayload.destination)
      );
    },
  },
  watch: {
    locationPathProp(newValue) {
      this.locationPath = newValue;
    },
    imageProcessingId() {
      setTimeout(() => {
        this.imageProcessingId = null;
      }, 5000);
    },
  },
  methods: {
    async filterDestinations(countryCode) {
      const country = this.contractLocations.find(
        (location) => location.location_code === countryCode
      );
      const destinations = country?.destination || [];
      if (destinations.length === 0) {
        return await locationApi.listDestinationsByCountry({
          limit: 500,
          country: country.id,
        });
      }

      return destinations;
    },
    loadData(payload = {}) {
      this.loading = true;
      this.$store
        .dispatch("assets/list", payload)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
    toggleModal() {
      if (!this.locationPath && this.locationPath === "")
        this.getLocationPathFromContract();
      this.assetsList = this.formWithImages[0].images_full
        ? this.formWithImages[0].images_full
        : [];
      if (this.dayLocations && this.dayLocations.length) {
        let location = this.dayLocations.reduce((max, obj) =>
          max.id > obj.id ? max : obj
        );
        if (location) {
          this.location = location.location_code;
        }
      }
      if (!this.showModal && !this.hasAssetsSearchDefaultPayload) {
        this.loadData({
          path: this.locationPath,
          category: this.category,
        });
      }
      this.showModal = !this.showModal;
    },
    toggleLoading(value) {
      this.isLoading = value;
    },
    handleAssetOnClick(value, image) {
      const index = this.assetsList
        ? this.assetsList.findIndex((list) => {
            return list.id == image.id;
          })
        : -1;
      if (index >= 0) {
        this.assetsList = this.assetsList.filter((asset, index) => index > 0);
      } else {
        if (
          this.type == this.constants.ASSET_TYPE.DAY ||
          this.type == this.constants.ASSET_TYPE.EXPORT ||
          !this.multiple
        ) {
          this.assetsList = [image];
        } else {
          this.assetsList.push(image);
        }
      }
    },
    handleSaveServicesAssets() {
      if (!this.assetsList.length && !this.allowEmpty) {
        return this.$buefy.toast.open({
          duration: 5000,
          message: "Please, select at least one asset to add.",
          position: "is-top",
          type: "is-danger",
        });
      }

      this.assetsList.forEach((img) => {
        const found = this.formWithImages[0].images_full
          ? this.formWithImages[0].images_full.findIndex(function (img2) {
              if (img2.id == img.id) return true;
            })
          : -1;

        if (found === -1) {
          if (this.multiple) {
            this.formWithImages[0].images_full.push(img);
          } else {
            this.formWithImages[0].images_full = [img];
          }
        }
      });
      if (this.assetsList.length === 0) {
        this.formWithImages[0].images_full = [];
      }
      this.$emit("update", this.formWithImages);
      this.toggleModal();
      this.assetsList = [];
    },
    getLocationPathFromContract() {
      const locationsPath = getLocationsPath(this.contractLocations);
      this.locationPath = locationsPath;
    },
    focusedGuideBoxClass(
      classDefault,
      step,
      bgWhite = false,
      extraValidator = null
    ) {
      const bgWhiteClass = bgWhite ? "bg-white" : "";
      const checkStep = step.length
        ? step.includes(this.userGuideStep)
        : this.userGuideStep === step;
      const resultExtraValidator = !extraValidator || extraValidator();
      return this.isUserGuideActive &&
        checkStep &&
        !this.isLoading &&
        resultExtraValidator
        ? `${classDefault} is-guide-step ${bgWhiteClass}`
        : classDefault;
    },
    nextStep() {
      if (this.isUserGuideActive) this.$store.dispatch("userguide/nextStep");
    },
    setImageProcessingId(id) {
      this.imageProcessingId = id;
    },
  },
};
</script>
<style>
.assets__container {
  width: 60rem;
  height: 48rem;
}
</style>
